import _ from 'lodash';
import { ChangeDetectorRef, Component, DestroyRef, HostListener, inject, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MdbTabChange, MdbTabsComponent, MdbTabsModule } from 'mdb-angular-ui-kit/tabs';
import { CoreModule } from 'app/core/core.module';
import { Store, select } from '@ngrx/store';
import { ToastService } from 'app/toast/services/toast.service';
import { AccountService } from 'app/account/services/account.service';
import { catchError, filter, first, of, Subject, switchMap, takeUntil } from 'rxjs';
import { AuthService } from 'app/router-wrapper/services/auth/auth.service';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { GoogleMapsAutocompleteModule } from 'app/google-maps-autocomplete/google-maps-autocomplete.module';
import { ImageService } from 'app/core/services/image.service';
import { DomSanitizer } from '@angular/platform-browser';
import { IconModule } from 'app/icon/icon.module';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { ModalStreetAddressService } from 'app/manage-p2p/services/modal-street-address/modal-street-address.service';
import { PopoverService } from 'app/core/services/popover.service';
import { selectOrgUser } from 'app/dashboard/features/dashboard.selectors';
import { CampaignService } from 'app/campaign/services/campaign.service';
import { ChooseImageModalService } from 'app/core/services/choose-image-modal.service';
import { MdbInputGoogleMapsAutocompleteComponent } from 'app/core/components/mdb-input-google-maps-autocomplete/mdb-input-google-maps-autocomplete.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ChipsComponent } from 'app/core/components/chips/chips.component';
import { CustomInputFileComponent } from 'app/core/components/custom-input-file/custom-input-file-component';
import { RouteReuseStrategyService } from 'app/router-wrapper/services/route-reuse-strategy-service/route-reuse-strategy-service.service';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'app-account',
  standalone: true,
  imports: [
    CommonModule,
    CoreModule, 
    MdbTabsModule, 
    MdbFormsModule, 
    ReactiveFormsModule,
    GoogleMapsAutocompleteModule,
    MdbInputGoogleMapsAutocompleteComponent,
    IconModule,
    MdbSelectModule,
    ChipsComponent,
    CustomInputFileComponent,
  ],
  templateUrl: './account.component.html',
  styleUrl: './account.component.scss',
})
export class AccountComponent implements OnInit {
  destroyRef = inject(DestroyRef)
  @ViewChild('tabs') tabs!: MdbTabsComponent;
  @HostListener('document:click', ['$event'])
  onHidePopover(event: MouseEvent) {
    if (window && window.getSelection && window.getSelection().toString().length) {
      return;
    }

    const { list } = this.popoverService;
    for(let key in list) {
      const popover = list[key];
      popover.hide();
    } 
  }

  public orgUser$ = this.store.pipe(
    select(selectOrgUser),
    first(user => !_.isNull(user)),
  );
  
  public localOrgData = null;
  public optedOutTaxReceiptText = 'Opt out of annual Tax Receipt.';
  public otpOutTaxReceiptButton = 'Opt Out';
  public optOutStatus = false
  public primaryEmailErrorText = 'This email is already in use.  Please provide other email.'

  public buttons = {
    name:false,
    mission:false,
    desc:false,
    url:false,
    address:false,
    phone:false,
    imageUrl:false,
    imageUrlLogo:false,
    pageBackgroundImage:false,
    primaryEmail:false,
    supportEmail:false,
    bgColor:false,
    textColor:false,
    pageBackgroundColor:false,
    optOutOf2020TaxReceipt:false,
    refundToggle:false,
    coverFeeSetting:false
  }

  public user = null;

  public orgName = new UntypedFormControl();
  public mission = new UntypedFormControl();
  public desc = new UntypedFormControl();
  public url = new UntypedFormControl();
  public address = new UntypedFormControl();
  public unitNum = new UntypedFormControl();
  public phone = new UntypedFormControl();
  public primaryEmail = new UntypedFormControl();
  public supportEmail = new UntypedFormControl();
  public bgColor = new UntypedFormControl();
  public textColor = new UntypedFormControl();
  public pageBackgroundColor = new UntypedFormControl();
  public coverFeeSetting = new UntypedFormControl();
  public optOutOf2020TaxReceipt = new UntypedFormControl();
  public refundToggleControl = new UntypedFormControl();
  public notifyRecipients = new UntypedFormControl();

  public oldPass = new UntypedFormControl('');
  public newPass = new UntypedFormControl('');
  public repeatName = new UntypedFormControl('');

  public imageFile = new UntypedFormControl();
  public imageDataUrl = new UntypedFormControl();
  public imageUrl = new UntypedFormControl();
  public images;

  public imageFileLogo = new UntypedFormControl();
  public imageDataUrlLogo = new UntypedFormControl();
  public imageUrlLogo = new UntypedFormControl();
  public imagesLogo;

  public imageFilePageBackgroundImage = new UntypedFormControl();
  public imageDataUrlPageBackgroundImage = new UntypedFormControl();
  public imageUrlPageBackgroundImage = new UntypedFormControl();
  public imagesPageBackgroundImage;

  public addressObject = null;
  public streetAddress = null;
  public showEnterManualy = false;

  public logoSize = {w:400, h:400};
  public coverSize = {w:800, h:400};

  public emailPattern = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  public emailPlaceholder = 'New E-Mail...';
  public oldPassErr = 'Empty password';
  public newPassErr = 'Empty password';
  public repeatPassErr = 'Empty password';

  public prevNotifyRecipients
  public notifyRecipientsValid = false;

  public popoverCoverImageText = "<span>This image is displayed to donors as the campaign image when no campaign image has been set. Find image requirements</span><a class='blue-text mdb-popover-text' href='https://docs.paybee.io/home/campaigns/general-campaign-settings/campaign-settings#image-requirements' target='_blank'>here</a> " 
  public popoverLogoText = "<span>This image is displayed to donors in all screens and emails from PayBee. Find image requirements</span><a class='blue-text mdb-popover-text' href='https://docs.paybee.io/home/campaigns/general-campaign-settings/campaign-settings#image-requirements' target='_blank'>here</a> " 
  public popoverDonorCoverFeeText = "<span>Find Fee & Pricing information</span><a class='blue-text mdb-popover-text' href='https://w.paybee.io/pricing' target='_blank'>here</a> "
  
  public isModalOpen = false;
  public addressText = '';

  public oldPhone = '';

  public href = '';
  public orgUrl = '';

  public deepCopyUser = null;

  public loggedInUser = null;

  public errorsMess = {
    url:'Website url cannot be empty',
    phone:"This phone is invalid. Please provide other phone number.",
    primaryEmail: 'Primary email is incorect',
    oldPass:'Empty password'
  }

  public readonly = false;
  public refundToggle = true;
  public skipRouteReuseStrategy = false;

  public takeUntilRouteReuseStrategySubject: Subject<any> = new Subject();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private store: Store,
    private toastService: ToastService,
    public accountService:AccountService,
    private authService: AuthService,
    private cdr: ChangeDetectorRef,
    public imageService: ImageService,
    private domSanitizer: DomSanitizer,
    private modalStreetAddressService: ModalStreetAddressService,
    private popoverService: PopoverService,
    private campaignService: CampaignService,
    private chooseImageModalService: ChooseImageModalService,
    private routeReuseStrategyService: RouteReuseStrategyService,
  ){ }

  ngOnInit(): void {

    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });

    this.routeReuseStrategyService.status = true;
    this.routeReuseStrategyService.routeReuseStrategySubject.pipe(
      filter(({ current, future }) => current.fragment !== future.fragment),
      takeUntil(this.takeUntilRouteReuseStrategySubject)
    ).subscribe(({ current, future }) => {
      if(this.skipRouteReuseStrategy) {
        this.skipRouteReuseStrategy = false;
        return false;
      }
      
      this.routeReuseStrategyService.status = false;
      switch(future.fragment) {
        case "organizationInfo":
          this.tabs.setActiveTab(0);
          break;
        case "account":
          this.tabs.setActiveTab(1);
          break;
        case "donorPages":
          this.tabs.setActiveTab(2);
          break;
        case "notifications":
          this.tabs.setActiveTab(3);
          break;
        case "password":
          this.tabs.setActiveTab(4);
          break;
        default:
          this.tabs.setActiveTab(0);
          break;
      }
      console.log(current, future);
    });

    this.localOrgData = window['localOrgData'];
    this.user = this.localOrgData.user
    let user = this.localOrgData.user;
    this.deepCopyUser = _.cloneDeep(user)
    this.orgName.setValue(user.name)
    this.mission.setValue(user.purpose)
    this.desc.setValue(user.desc)
    this.url.setValue(user.url)
    this.phone.setValue(user.phone)
    this.oldPhone = user.phone;
    this.imageDataUrl.setValue(user.imageUrl === '' ? '/images/blank_2x1.png' : user.imageUrl)
    this.imageDataUrlLogo.setValue(user.logoUrl === '' ? '/images/blank_2x1.png' : user.logoUrl)
    this.imageDataUrlPageBackgroundImage.setValue(user.pageBackgroundImage !== '' ? user.pageBackgroundImage : '/images/blank_2x1.png')
    this.primaryEmail.setValue(user.email)
    this.supportEmail.setValue(user.supportEmail)
    this.bgColor.setValue(user.bannerBkColor || '#272064')
    this.pageBackgroundColor.setValue(user.pageBackgroundColor || '#ffffff')
    this.textColor.setValue(user.bannerTextColor === 'white' ? '#ffffff' : user.bannerTextColor || '#ffffff')
    this.coverFeeSetting.setValue(user.coverFeeSetting, {emitEvent: false});
    this.optOutOf2020TaxReceipt.setValue(!user.optOutOf2020TaxReceipt, {emitEvent: false});
    this.refundToggleControl.setValue(user.enableRefund);
    this.notifyRecipients.setValue(user.notifyRecipients || [])
    this.prevNotifyRecipients = [...user.notifyRecipients || []];

    this.href =  "/@" +  window['localOrgData'].user.handle;
    this.orgUrl = `${window.location.protocol}//${window.location.hostname}/@${window['localOrgData'].user.handle}`;


    let address = user.streetAddress;
    let streetAddressText = window['utils'].getStreetAddressText(address)
    if(streetAddressText){
      this.addressObject = address;
      this.streetAddress = user.streetAddress
      this.address.setValue(user.streetAddress)
      this.unitNum.setValue(user.streetAddress.unitNum)
      this.showEnterManualy = false;
    }else{
      this.address.setValue('');
      this.unitNum.setValue('');
      this.showEnterManualy = true;
    }

    // this.setTaxReceiptButtonAndStatus(user.optOutOf2020TaxReceipt);


    this.orgName.valueChanges.pipe(
      filter(() => !this.readonly),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((val)=>{
      const trimmedValue = val.trim();
      if(trimmedValue == ''){
        this.buttons.name = false;
      }

      if (val !== trimmedValue) {
        this.orgName.setValue(trimmedValue);
      }

      if(this.deepCopyUser){
        if(val !== this.deepCopyUser?.name){
          this.buttons.name = true;
        }else{
          this.buttons.name = false;
        }
      }
    })

    this.mission.valueChanges.pipe(
      filter(() => !this.readonly),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((val)=>{
      const trimmedValue = val.trim();

      if(trimmedValue == ''){
        this.buttons.mission = false;
      }

      if (val !== trimmedValue) {
        this.mission.setValue(trimmedValue);
      }

      if(this.deepCopyUser){
        if(val !== this.deepCopyUser?.purpose){
          this.buttons.mission = true;
        }else{
          this.buttons.mission = false;
        }
      }
    })

    this.desc.valueChanges.pipe(
      filter(() => !this.readonly),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((val)=>{
      this.buttons.desc = true;
    })

    this.url.valueChanges.pipe(
      filter(() => !this.readonly),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((val)=>{
      this.buttons.url = true;
      const trimmedValue = val.trim();

      if(trimmedValue == ''){
        this.buttons.url = false;
      }

      if (val !== trimmedValue) {
        this.url.setValue(trimmedValue);
      }

      if(this.deepCopyUser){
        if(val !== this.deepCopyUser?.url){
          this.buttons.url = true;
        }else{
          this.buttons.url = false;
        }
      }
    })

    this.address.valueChanges.pipe(
      filter(() => !this.readonly),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((val)=>{
      if(!val){
        this.unitNum.setValue('');
      }
      this.buttons.address = true;
      this.showEnterManualy = true;
      this.address.setErrors(null)
    })

    this.unitNum.valueChanges.pipe(
      filter(() => !this.readonly),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((val)=>{
      this.buttons.address = true;
    })

    this.phone.valueChanges.pipe(
      filter(() => !this.readonly),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((val)=>{
      // if(val){
      //   let phoneLength = val.replace(/\D/g, '').length
      // }
      // if(this.deepCopyUser){
      //   if(phoneLength == 11 && val !== this.deepCopyUser?.phone){
      //     this.buttons.phone = true;
      //   }else{
      //     this.buttons.phone = false;
      //   }
      // }
      // this.phone.setErrors(null)
      if(this.oldPhone !== val ){
        this.buttons.phone = true;
      }else{
        this.buttons.phone = false;
      }
      this.phone.setErrors(null)
    })

    this.imageFile.valueChanges.pipe(
      filter(value => !_.isNull(value)),
      filter(() => !this.readonly),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe(value => {
      this.images = value;
      const windowURL = window.URL || window.webkitURL;
      this.buttons.imageUrl = true;
      if (value && value.length) {
        value.forEach(image => {
          const url = windowURL.createObjectURL(image);
          this.imageService.cropper({
            url: this.domSanitizer.bypassSecurityTrustUrl(url),
            id: 'cover-image',
            name: image.name,
            type: image.type,
          });
        });
      } else {
        const url = windowURL.createObjectURL(value);
        this.imageService.cropper({
          url: this.domSanitizer.bypassSecurityTrustUrl(url),
          id: 'cover-image',
          name: value.name,
          type: value.type,
        });
      }
    });

    this.imageService.imageDataUrlSubject.pipe(
      filter(({ id }) => id === 'cover-image'),
      filter(() => !this.readonly),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe(({ result }) => {
      this.imageDataUrl.setValue(result);
    });

    this.imageService.imageSubject.pipe(
      filter(({ id }) => id === 'cover-image'),
      filter(() => !this.readonly),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe(({ result }) => {
      if(result === false) {
        this.resetImage('cover');
      } else {
        this.imageUrl.setValue(result.imageUrl);
      }

      this.cdr.markForCheck();
    });


    this.imageFileLogo.valueChanges.pipe(
      filter(value => !_.isNull(value)),
      filter(() => !this.readonly),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe(value => {
      this.imagesLogo = value;
      const windowURL = window.URL || window.webkitURL;
      this.buttons.imageUrlLogo = true;
      if (value && value.length) {
        value.forEach(image => {
          const url = windowURL.createObjectURL(image);
          this.imageService.cropper({
            url: this.domSanitizer.bypassSecurityTrustUrl(url),
            id: 'logo-image',
            name: image.name,
            type: image.type,
            aspectRatio:1
          });
        });
      } else {
        const url = windowURL.createObjectURL(value);
        this.imageService.cropper({
          url: this.domSanitizer.bypassSecurityTrustUrl(url),
          id: 'logo-image',
          name: value.name,
          type: value.type,
          aspectRatio:1
        });
      }
    });

    this.imageService.imageDataUrlSubject.pipe(
      filter(({ id }) => id === 'logo-image'),
      filter(() => !this.readonly),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe(({ result }) => {
      this.imageDataUrlLogo.setValue(result);
    });

    this.imageService.imageSubject.pipe(
      filter(({ id }) => id === 'logo-image'),
      filter(() => !this.readonly),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe(({ result }) => {
      if(result === false) {
        this.resetImage('logo');
      } else {
        this.imageUrlLogo.setValue(result.imageUrl);
      }

      this.cdr.markForCheck();
    });


    this.imageFilePageBackgroundImage.valueChanges.pipe(
      filter(value => !_.isNull(value)),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe(value => {
      this.imagesPageBackgroundImage = value;
      const windowURL = window.URL || window.webkitURL;
      this.buttons.pageBackgroundImage = true;
      if (value && value.length) {
        value.forEach(image => {
          const url = windowURL.createObjectURL(image);
          this.imageService.cropper({
            url: this.domSanitizer.bypassSecurityTrustUrl(url),
            id: 'pageBackgroundImage-image',
            name: image.name,
            type: image.type,
            aspectRatio: null
          });
        });
      } else {
        const url = windowURL.createObjectURL(value);
        this.imageService.cropper({
          url: this.domSanitizer.bypassSecurityTrustUrl(url),
          id: 'pageBackgroundImage-image',
          name: value.name,
          type: value.type,
          aspectRatio: null
        });
      }
    });

    this.imageService.imageDataUrlSubject.pipe(
      filter(({ id }) => id === 'pageBackgroundImage-image'),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe(({ result }) => {
      this.imageDataUrlPageBackgroundImage.setValue(result);
    });

    this.imageService.imageSubject.pipe(
      filter(({ id }) => id === 'pageBackgroundImage-image'),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe(({ result }) => {
      if(result === false) {
        this.resetImage('pageBackgroundImage');
      } else {
        this.imageUrlPageBackgroundImage.setValue(result.imageUrl);
      }

      this.cdr.markForCheck();
    });

    this.primaryEmail.valueChanges.pipe(
      filter(() => !this.readonly),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((val)=>{

      const trimmedValue = val.trim();
      if(trimmedValue == ''){
        this.buttons.primaryEmail = false;
      }

      if (val !== trimmedValue) {
        this.primaryEmail.setValue(trimmedValue);
      }

      if(this.deepCopyUser){
        if(val !== this.deepCopyUser?.email){
          this.buttons.primaryEmail = true;
        }else{
          this.buttons.primaryEmail = false;
        }
      }

      this.primaryEmail.setErrors(null)
    })

    this.supportEmail.valueChanges.pipe(
      filter(() => !this.readonly),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((val)=>{
      this.buttons.supportEmail = true;


      const trimmedValue = val.trim();
      if(trimmedValue == ''){
        this.buttons.supportEmail = false;
      }

      if (val !== trimmedValue) {
        this.supportEmail.setValue(trimmedValue);
      }

      if(this.deepCopyUser){
        if(val !== this.deepCopyUser?.supportEmail){
          this.buttons.supportEmail = true;
        }else{
          this.buttons.supportEmail = false;
        }
      }
      this.supportEmail.setErrors(null)
    })

    this.bgColor.valueChanges.pipe(
      filter(() => !this.readonly),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((val)=>{
      this.buttons.bgColor = true;
    })

    this.pageBackgroundColor.valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((val)=>{
      this.buttons.pageBackgroundColor = true;
    })

    this.textColor.valueChanges.pipe(
      filter(() => !this.readonly),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((val)=>{
      this.buttons.textColor = true;
    })

    this.coverFeeSetting.valueChanges.pipe(
      filter(() => !this.readonly),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((val)=>{
      this.buttons.coverFeeSetting = true;``
    })

    this.optOutOf2020TaxReceipt.valueChanges.pipe(
      filter(() => !this.readonly),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((val)=>{
      this.buttons.optOutOf2020TaxReceipt = true;
    })

    this.refundToggleControl.valueChanges.pipe(
      filter(() => this.refundToggle),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((val)=>{
      this.buttons.refundToggle = true;
    });

    this.notifyRecipients.valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((val)=>{
      this.notifyRecipients.setErrors(null)
    })

    this.orgUser$.pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((user: any) => {
      const { access } = user.loggedInUser ? user.loggedInUser: {
        access: [0, 1]
      };
      this.user = user;
      this.loggedInUser = user.loggedInUser ? user.loggedInUser : null;
      this.readonly = access.findIndex(access => access == 1) >= 0 ? false: true;
      this.refundToggle = access.findIndex(access => access == 0) >= 0 ? true: false;
      if(this.readonly) {
        this.coverFeeSetting.disable({emitEvent: false});
        this.optOutOf2020TaxReceipt.disable({emitEvent: false});
      } else {
        this.coverFeeSetting.enable({emitEvent: false});
        this.optOutOf2020TaxReceipt.enable({emitEvent: false});
      }

      if(this.refundToggle) {
        this.refundToggleControl.enable();
      } else {
        this.refundToggleControl.disable();
      }
    });
  }

  ngAfterViewInit(): void {
    const fragment = this.route.snapshot.fragment;
    switch(fragment) {
      case "organizationInfo":
        this.tabs.setActiveTab(0);
        break;
      case "account":
        this.tabs.setActiveTab(1);
        break;
      case "donorPages":
        this.tabs.setActiveTab(2);
        break;
      case "notifications":
        this.tabs.setActiveTab(3);
        break;
      case "password":
        this.tabs.setActiveTab(4);
        break;
      default:
        this.tabs.setActiveTab(0);
        break;
    }
  }

  // setTaxReceiptButtonAndStatus(optOutStatus) {
  //   if(optOutStatus != undefined && optOutStatus) {
  //     this.optOutStatus = true;
  //     this.otpOutTaxReceiptButton = 'Opt In'
  //     this.optedOutTaxReceiptText = "You are currently opted out. Opt-in for annual tax receipt."
  //   } else {     
  //     this.optOutStatus = false;  
  //     this.otpOutTaxReceiptButton = 'Opt Out' 
  //     this.optedOutTaxReceiptText = "You are currently opted in. Opt-out from annual tax receipt."
  //   }
  // }

  getError(type){
    return this.errorsMess[type];
  }

  onUpdateClick(type){
    let reqData = this.getParamsAndUrl(type);
    
    if(!reqData.p){
      return
    }

    this.showEnterManualy = false;

    switch(type){
      case 'name':
        if(this.orgName.value.trim() == ''){
          this.orgName.setErrors({'incorrect': true})
          return
        }
        this.updateFild(reqData,type)
        break
      case 'mission':
        if(this.mission.value.trim() == ''){
          this.errorsMess.url = 'Website url cannot be empty'
          this.mission.setErrors({'incorrect': true})
          return
        }
        this.updateFild(reqData,type)
        break
      case 'url':
        if(this.url.value.trim() == ''){
          this.url.setErrors({'incorrect': true})
          return
        }
        this.updateFild(reqData,type)
        break
      case 'phone':        
        if(this.phone.value != undefined && this.phone.value.replace(/\D/g, '').length < 11){
          this.errorsMess.phone = 'Invalid phone number'
          this.phone.setErrors({'incorrect': true})
          return
        }
        this.updateFild(reqData,type)
        break
      case 'desc':
      case 'address':
      case 'imageUrl':
      case 'imageUrlLogo':
      case 'supportEmail':
      case 'bgColor':
      case 'pageBackgroundColor':
      case 'pageBackgroundImage':
      case 'textColor':
      case 'coverFeeSetting':
        this.updateFild(reqData,type)
        break
      case 'notifyRecipients':
          this.updateNotifyRecipients(reqData)
          break
      case 'primaryEmail':
        if(this.primaryEmail.value.trim() == ''){
          this.errorsMess.primaryEmail = 'Primary email  cannot be empty.'
          this.primaryEmail.setErrors({'incorrect': true})
          return
        }
        this.updatePrimaryEmail(reqData);
        break
      case 'optOutOf2020TaxReceipt':
        this.updateOptOutOf2020TaxReceipt();
        break
      case 'refundToggle':
        this.updateRefundToggle();
        break
    }
  }

  updateFild(reqData,type){
    this.accountService.onSaveField(reqData.p, reqData.url).pipe(
      takeUntilDestroyed(this.destroyRef),
      catchError((error) => {
        if(error.error?.errorCode == "InvalidPhone"){
          this.errorsMess.phone = 'This phone is invalid. Please provide other phone number.'
          this.phone.setErrors({'incorrect': true})
        }
        if(error.errorCode == "InvalidEmail"){
          this.supportEmail.setErrors({'incorrect': true})
        }
        if(error.error?.errorCode == "InvalidURL"){
          this.errorsMess.url = 'Invalid Website Url'
          this.url.setErrors({'incorrect': true})
        }
        return of(null);
      })
    ).subscribe((val)=>{
      if(val){
        this.getDonor();
        this.toastService.showSuccess(this.getToasterText(type),{delay:2000});
        this.buttons[type] = false;
      }
    })
  }

  updateNotifyRecipients(reqData){
    let arraysAreEqual = this.arraysAreEqual(this.prevNotifyRecipients, this.notifyRecipients.value);
    if(arraysAreEqual){
      this.notifyRecipients.setErrors({'incorrect': true})
    }else{
      this.accountService.onSaveField(reqData.p, reqData.url).pipe(
        takeUntilDestroyed(this.destroyRef),
      ).subscribe((val)=>{
        if(val){
          let params = {updateNotifyRecipients:true}
          this.getDonor(params);
          this.toastService.showSuccess(this.getToasterText('notifyRecipients'),{delay:2000});
          this.buttons['notifyRecipients'] = false;
        }
      })
    }
  }

  updatePrimaryEmail(reqData){
    this.checkIsPrimaryEmailAvailable().pipe(
      takeUntilDestroyed(this.destroyRef),
      catchError((error) => {
        if(error.errorCode = "InvalidEmail"){
          this.errorsMess.primaryEmail = 'Invalid Email.'
          this.primaryEmail.setErrors({'incorrect': true})
        }
        return of(null);
      })
    ).subscribe((result:{isAvailable:boolean} | null)=>{
      if(result){
        let isAvailable = result.isAvailable;
        if(!isAvailable){
          this.errorsMess.primaryEmail= 'This email is already in use.  Please provide other email.'
          this.primaryEmail.setErrors({'incorrect': true})
        }else{
          this.accountService.onSaveField(reqData.p, reqData.url).pipe(
            takeUntilDestroyed(this.destroyRef),
            ).subscribe((val)=>{
              if(val){
                this.getDonor();
                this.toastService.showSuccess('Primary email  was successfully updated',{delay:2000});
                this.buttons['primaryEmail'] = false;
              }
            })
        }
      }
    })
  }

  updateOptOutOf2020TaxReceipt(){
    let optOut = !this.optOutOf2020TaxReceipt.value
    this.accountService.changeOptOutTaxReceipt({optOut}).pipe(  
      takeUntilDestroyed(this.destroyRef),
    ).subscribe(res=>{
      if(res){
        this.getDonor();
        this.toastService.showSuccess('Updated',{delay:2000});
        this.buttons['optOutOf2020TaxReceipt'] = false;
      }
    })
  } 

  updateRefundToggle() {
    let refund = this.refundToggleControl.value;
    this.accountService.changeRefundToggle(this.user.id, refund).pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe(result => {
      if(result) {
        this.getDonor();
        this.toastService.showSuccess('Updated', {
          delay:2000
        });
        this.buttons['refundToggle'] = false;
      }
    })
  }

  getToasterText(type){
    switch(type){
      case 'name':
        return "Organization Name was successfully updated"
      case 'mission':
        return 'Short Mission statement was successfully updated'
      case 'desc':
        return "Description was successfully updated"
      case 'url':
        return 'Website URL was successfully updated'
      case 'address':
        return 'Address was successfully updated'
      case 'phone':
        return 'Phone was successfully updated'
      case 'imageUrl':
        return 'Cover Image was successfully updated'
      case 'imageUrlLogo':
        return 'Logo Image was successfully updated'
      case 'pageBackgroundImage':
        return 'Page Background Image was successfully updated'
      case 'primaryEmail':
        return 'Primary email  was successfully updated'
      case 'supportEmail':
        return 'Support email was successfully updated'
      case 'bgColor':
        return 'Background Color was successfully updated'
      case 'pageBackgroundColor':
        return 'Page Background Color was successfully updated'
      case 'textColor':
        return 'Text Color was successfully updated'
      case 'coverFeeSetting':
        return 'Donor Cover Settings was successfully updated'
      case 'optOutOf2020TaxReceipt':
        return 'Updated'
      case 'refundToggle':
        return 'Updated'
      case 'notifyRecipients':
        return 'Updated'
    }
  }

  onCanselClick(type){
    switch(type){
      case 'name':
        this.orgName.setValue(this.localOrgData.user.name)
        this.buttons.name = false
        break
      case 'mission':
        this.mission.setValue(this.localOrgData.user.purpose)
        this.buttons.mission = false
        break
      case 'desc':
        this.desc.setValue(this.localOrgData.user.desc)
        this.buttons.desc = false
        break
      case 'url':
        this.url.setValue(this.localOrgData.user.url)
        this.buttons.url = false
        break
      case 'address':
        let unitNum = this.localOrgData.user.streetAddress.unitNum
        this.address.setValue(this.localOrgData.user.streetAddress)
        this.unitNum.setValue(unitNum)
        this.buttons.address = false
        this.showEnterManualy = true
        break
      case "phone":
        this.phone.setValue(this.localOrgData.user.phone)
        this.buttons.phone = false
        break
      case "imageUrl":
        this.imageDataUrl.setValue(this.localOrgData.user.imageUrl)
        this.buttons.imageUrl = false
        break
      case "imageUrlLogo":
        this.imageDataUrlLogo.setValue(this.localOrgData.user.logoUrl)
        this.buttons.imageUrlLogo = false
        break
      case "pageBackgroundImage":
        this.imageDataUrlPageBackgroundImage.setValue(this.localOrgData.user.pageBackgroundImage !== '' ? this.localOrgData.user.pageBackgroundImage : '/images/blank_2x1.png')
        this.buttons.pageBackgroundImage = false
        break
      case "primaryEmail":
        this.primaryEmail.setValue(this.localOrgData.user.email)
        this.buttons.primaryEmail = false
        break
      case "supportEmail":
        this.supportEmail.setValue(this.localOrgData.user.supportEmail)
        this.buttons.supportEmail = false
        break
      case "bgColor":
        this.bgColor.setValue(this.localOrgData.user.bannerBkColor)
        this.buttons.bgColor = false
        break
      case "textColor":
        this.textColor.setValue(this.localOrgData.user.bannerTextColor)
        this.buttons.textColor = false
        break
      case "pageBackgroundColor":
        this.pageBackgroundColor.setValue(this.localOrgData.user.pageBackgroundColor)
        this.buttons.pageBackgroundColor = false
        break
      case "optOutOf2020TaxReceipt":
        this.optOutOf2020TaxReceipt.setValue(!this.localOrgData.user.optOutOf2020TaxReceipt, {emitEvent: false});
        // this.buttons.optOutOf2020TaxReceipt = false
        break
      case "refundToggle":
        this.refundToggleControl.setValue(this.localOrgData.user.enableRefund)
        this.buttons.refundToggle = false
        break
    }
  }
  
  arraysAreEqual(arr1: string[], arr2: string[]): boolean {
    if (arr1.length !== arr2.length) {
      return false;
    }

    const sortedArr1 = arr1.slice().sort();
    const sortedArr2 = arr2.slice().sort();
  
    for (let i = 0; i < sortedArr1.length; i++) {
      if (sortedArr1[i] !== sortedArr2[i]) {
        return false;
      }
    }
  
    return true;
  }

  getParamsAndUrl(type){
    switch(type){
      case 'name':
       return {p:{name:this.orgName.value},url:'api/org/name/update'}

      case 'mission':
      return {p:{purpose:this.mission.value},url:'/api/org/mission/update'}

      case 'desc':
        return {p:{desc:this.desc.value},url:'/api/org/desc/update'}

      case 'url':
        return {p:{url:this.url.value},url:'/api/org/url/update'}

      case 'address':
        let streetAddress = this.address.value;

        if(!streetAddress){
          this.address.setErrors({'incorrect': true})
          return {p:null,url:''}
          // streetAddress = {city:"",country:"",state:"",street1:"",street2:"",unitNum:"",zip:""}
          // return {p:{streetAddress},url:'/api/org/address/update'}
        }else{
          if(typeof streetAddress !== "string"){
            streetAddress.unitNum = this.unitNum.value
          }else{
            this.addressObject.unitNum = this.unitNum.value 
            streetAddress = this.addressObject;
          }
      
          return {p:{streetAddress},url:'/api/org/address/update'}
        }

      case 'phone':
        return {p:{phone:this.phone.value},url:'/api/org/phone/update'}

      case 'imageUrl':
        let coverImageUrl = this.imageUrl.value === '/images/blank_2x1.png' ? '' : this.imageUrl.value; 
        return {p:{coverImage:coverImageUrl},url:'/api/org/cover-image/update'}

      case 'imageUrlLogo':
        let logoUrl = this.imageUrlLogo.value === '/images/blank_2x1.png' ? '' : this.imageUrlLogo.value; 
        return {p:{logo:logoUrl},url:'/api/org/logo/update'}

      case 'pageBackgroundImage':
        return {p:{imageUrl:this.imageUrlPageBackgroundImage.value},url:'/api/org/page-back-image/update'}

      case 'primaryEmail':
          return {p:{email:this.primaryEmail.value},url:'/api/org/email/update'} 

      case 'supportEmail':
        return {p:{supportEmail:this.supportEmail.value},url:'/api/org/support-email/update'} 

      case 'bgColor':
        return {p:{colorCode:this.bgColor.value},url:'/api/org/banner-bk-color/update'} 

      case 'pageBackgroundColor':
        return {p:{colorCode:this.pageBackgroundColor.value},url:'/api/org/page-back-color/update'} 

      case 'textColor':
        return {p:{colorCode:this.textColor.value},url:'/api/org/banner-text-color/update'} 

      case 'coverFeeSetting':
        return {p:{coverFeeSetting:+this.coverFeeSetting.value},url:'/api/org/cover-fee/update'} 
      
      case 'optOutOf2020TaxReceipt':
        return {p:{enable:this.optOutOf2020TaxReceipt.value},url:'/api/org/cover-fee/update'} 

      case 'refundToggle':
        return {p:{orgId:this.user.id,enable:this.refundToggleControl.value},url:'/api/admin/org/refund/enable'} 

      case 'notifyRecipients':
          return {p:{emails:this.notifyRecipients.value},url:'/api/org/updateNotify'} 
    }
  }

  checkIsPrimaryEmailAvailable(){
   return this.accountService.isEmailAvailable(this.primaryEmail.value).pipe(
      takeUntilDestroyed(this.destroyRef),
    )
  }

  getDonor(params = null){
    this.authService.getOrgUser(true).pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((res)=>{
      this.deepCopyUser = _.cloneDeep(res)
      this.tabs.setActiveTab(this.accountService.tabs)
      if(params?.updateNotifyRecipients){
        this.prevNotifyRecipients = [...res.notifyRecipients || []]
      }
    })
  }

  openChooseImageModal(type = 0, placeOfCall = null) { // 0 for 2x1, 1 for 1x1
    const params = {
      start: 0,
      returnCount: 40,
      filterBy:[type]
    }

    this.campaignService.getOrganizationImages(params).pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((imageList: any)=> {
      const list = imageList || [];
      const images = list.filter((image) => image.type === type)
      const modalRef = this.chooseImageModalService.open({ images, type });
    
      modalRef.onClose.pipe(
        takeUntilDestroyed(this.destroyRef),
      ).subscribe((imageUrl) =>{
        if(imageUrl) {
          switch (placeOfCall) {
            case 'cover':
              this.imageDataUrl.setValue(imageUrl);
              this.imageUrl.setValue(imageUrl);
              this.buttons.imageUrl = true;
              break;
            case 'logo':
              this.imageDataUrlLogo.setValue(imageUrl);
              this.imageUrlLogo.setValue(imageUrl);
              this.buttons.imageUrlLogo = true;
              break;
            case 'pageBg':
              this.imageDataUrlPageBackgroundImage.setValue(imageUrl);
              this.imageUrlPageBackgroundImage.setValue(imageUrl);
              this.buttons.pageBackgroundImage = true;
              break;
          }
        }
        this.chooseImageModalService.modalRef = null;
      })
    })
  }


  resetImage(type) {
    if(this.readonly) {
     return;
    }

    switch (type){
      case "cover":
        this.imageFile.setValue(null);
        this.imageDataUrl.setValue('/images/blank_2x1.png');
        this.imageUrl.setValue('/images/blank_2x1.png');
        this.buttons.imageUrl = true;
        break
      case 'logo':
        this.imageFileLogo.setValue(null);
        this.imageDataUrlLogo.setValue('/images/blank_2x1.png');
        this.imageUrlLogo.setValue('/images/blank_2x1.png');
        this.buttons.imageUrlLogo = true;
        break
      case 'pageBackgroundImage':
        this.imageFilePageBackgroundImage.setValue(null);
        this.imageDataUrlPageBackgroundImage.setValue('/images/blank_2x1.png');
        this.imageUrlPageBackgroundImage.setValue('/images/blank_2x1.png');
        this.buttons.pageBackgroundImage = true;
        break
    }
  }

  onTabChange(event: MdbTabChange): void{
    const currentTab = event.index;
    this.accountService.tabs = event.index;

    let fragment = null;
    switch(event.index) {
      case 0:
        fragment = "organizationInfo";
        break;
      case 1:
        fragment = "account";
        break;
      case 2:
        fragment = "donorPages";
        break;
      case 3:
        fragment = "notifications";
        break;
      case 4:
        fragment = "password";
        break;
      default:
        fragment ="organizationInfo";
        break;
    }
    this.router.navigate([], { relativeTo: this.route, fragment });
    this.skipRouteReuseStrategy = true;
  }

  onChangePassword(){

    let oldPassValue = this.oldPass.value.trim();
    let newPassValue = this.newPass.value.trim();
    let repeatNameValue = this.repeatName.value.trim();

    if(oldPassValue == ''){
      this.oldPass.setErrors({'incorrect': true})
      return
    }

    if(newPassValue == ''){
      this.newPass.setErrors({'incorrect': true})
      return
    }

    if(window['utils'].checkPassStrength(newPassValue) == "weak"){
      this.newPassErr = 'Weak password, please add numbers or special characters to it'
      this.newPass.setErrors({'incorrect': true})
      return
    }

    if(newPassValue !== repeatNameValue){
      this.repeatPassErr = "Passwords don't match"
      this.repeatName.setErrors({'incorrect': true})
      return
    }

    let reqData = {old_pass:oldPassValue,new_pass:newPassValue}

    this.orgUser$.pipe(
      first(),
      switchMap((user: any) => {
        return user.loggedInUser ?
          this.accountService.onChangeAccountPassword(reqData):
          this.accountService.onChangeOrganizationPassword(reqData);
      }),
      catchError((error) => {
        if(error.error?.errorCode == "InvalidCurrentPassword"){
          this.errorsMess.oldPass = 'Invalid Password'
          this.oldPass.setErrors({'incorrect': true})
        } 
        return of(null);
      })
    ).subscribe((val)=>{
      if(val){
        this.oldPass.setValue('');
        this.newPass.setValue('');
        this.repeatName.setValue('');
        this.toastService.showSuccess('Password was successfully updated',{delay:2000});
      }
    });
  }

  onCancelPassword(){
    this.oldPass.setValue('');
    this.newPass.setValue('');
    this.repeatName.setValue('');
  }

  onEnterManuallyClick(){
    this.isModalOpen = true;

    const modalRef = this.modalStreetAddressService.open(null);
    
    modalRef.onClose.pipe().subscribe((selectedAddress) =>{
      if(selectedAddress && selectedAddress !== 'close') {
        const addressText = window['utils'].getStreetAddressText(selectedAddress);
        this.address.setValue(addressText);

        if(selectedAddress?.unitNum) {
          this.unitNum.setValue(selectedAddress.unitNum);
        }

        this.addressObject = selectedAddress
        this.address.setValue(selectedAddress);
      }
      this.modalStreetAddressService.modalRef = null;
      this.isModalOpen = false;
    })
  }
}
